import { useState } from 'react';

import { BULK_DEVICE_PAGE_SIZE } from '../../constants/pagination.js';
import { useDevices } from '../../hooks/useDevices';
import { useIntl } from '../../hooks/useIntl.js';
import type { Tag } from '../../types/tag';
import { Badge, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui';

interface TagBadgeProps {
  tag: Tag;
}

export function TagBadge({ tag }: TagBadgeProps) {
  const intl = useIntl();
  const [isOpen, setIsOpen] = useState(false);
  const { data: devicesPage, isLoading } = useDevices(
    { tagIds: [tag.id], pageSize: BULK_DEVICE_PAGE_SIZE },
    isOpen,
  );
  const devices = devicesPage?.devices;

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip open={isOpen} onOpenChange={setIsOpen}>
        <TooltipTrigger asChild>
          <Badge variant="secondary" className="text-xs cursor-help">
            {tag.name}
          </Badge>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs">
          {isLoading ? (
            <div className="text-xs text-gray-500">Loading devices...</div>
          ) : !devices || devices.length === 0 ? (
            <div className="text-xs text-gray-500">No devices with this tag</div>
          ) : (
            <div className="space-y-1">
              <div className="text-xs font-semibold text-gray-700 mb-2">
                {intl.formatMessage({ id: 'devices.title' })} ({devices.length}):
              </div>
              <div className="space-y-1 max-h-48 overflow-y-auto">
                {devices.map((device) => (
                  <div key={device.id} className="text-xs text-gray-600 font-mono">
                    {device.serial}
                  </div>
                ))}
              </div>
            </div>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
